import { Inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { MapColorGeneratorActions } from './action-types'
import { map, switchMap, take } from 'rxjs/operators'
import { selectMapColorGeneratorFeature } from './map-color-generator.selectors'
import { MapColorGeneratorService } from '../../../services/map-color-generator.service'
import cloneDeep from 'lodash/cloneDeep'

@Injectable()
export class MapColorGeneratorEffects {

    getNextColors$: Observable<any>

    constructor(
        @Inject(Actions) private actions$: Actions,
        @Inject(Store) private store: Store,
        @Inject(MapColorGeneratorService) private mapColorGeneratorService: MapColorGeneratorService,
    ) {
        this.getNextColors$ = createEffect(() => this.actions$.pipe(
            ofType(MapColorGeneratorActions.getNextColors),
            switchMap(action => {
                return this.store.select(selectMapColorGeneratorFeature).pipe(
                    take(1),
                    map((colorMap) => {
                        if (colorMap[action.ident]?.length >= action.num) {
                            return MapColorGeneratorActions.noAction
                        }
                        let colorList = this.mapColorGeneratorService.getColorList()
                        if (colorMap.offset + action.num > colorList.length) {
                            colorList = this.mapColorGeneratorService.generateColorList(colorMap.offset + action.num)
                        }
                        const updatedColorMap = cloneDeep(colorMap)
                        updatedColorMap[action.ident] = colorList.slice(colorMap.offset, colorMap.offset + action.num)

                        return MapColorGeneratorActions.setColorMap({ colorMap: updatedColorMap, colorOffset: updatedColorMap.offset + action.num })
                    }))
            }),
        ))

    }
}